const userRolesIds = {  
  director: "CC6325AA-8B93-40BA-BAC0-900B5EA038E9", 
};

export default userRolesIds;
